const styles = {
  container: {
    flexDirection: "column" as "column",
    flex: 1,
  },

  inputFieldContainer: {
    flexDirection: "row" as "row",
    alignItems: "center",

    backgroundColor: "#ffffff",
  },

  inputFieldBottomLine: {
    borderBottomColor: "#e8e8e8",
    borderBottomWidth: 1,
  },

  defaultMarginBottom: {
    // marginBottom: 10,
  },

  inner: {
    flex: 1,
    flexDirection: "row" as "row",
    paddingLeft: 3,
    paddingRight: 15,
    paddingVertical: 0,
    height: "100%",
  },

  unitContainer: {
    paddingLeft: 1,
    marginTop: 2,
    marginBottom: 2,
  },

  unitText: {
    textAlignVertical: "center",
    color: "black",
  },

  inputField: {
    width: "100%",
    flex: 1,

    margin: 0,

    fontSize: 15,

    alignSelf: "center",
    color: "black",
  },

  inputFieldBorder: {
    border: "1px solid #e8e8e8",
  },

  inputFieldFocused: {
    borderBottomColor: "black",
  },

  inputFieldFocusedBordered: {
    borderColor: "black",
  },

  submitButtonContainer: {
    minWidth: 105,
    paddingLeft: 5,
  },

  submitButton: {
    // position: 'absolute',
    top: 10,
    paddingTop: 5,
    paddingBottom: 5,
    right: 0,
    minWidth: 105,
  },

  descriptionText: {
    fontSize: 12,
    // lineHeight: 12,
    color: "black",
  },
}

export default styles
